// @flow
import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import MainTemplate from 'components/templates/MainTemplate'
import {
  ReputationListHeader,
  HostSummary,
  ReputationListItem,
} from 'components/shared'
import Breadcrumbs from 'components/shared/Breadcrumbs'
import { viewerFragment, companyManagedFragment } from 'common/fragments'
import { ownerFragment, searchMasterFragment } from 'common/fragments/www'
import type { Thumbnail } from 'types/room'
import Path from 'routes/path'
import TopicPage from 'components/pages/TopicPage'
import type { Topic } from 'types/stay/topic'
import { imagePath } from 'frontend_core/dist/helpers/image'

type PropTypes = {
  data: {
    topic: Topic,
  },
  match: {
    params: {
      topicUid: ?string,
    },
  },
  staticContext: Object,
  location: {
    pathname: string,
  },
  config: {
    ORIGIN: string,
  },
}

const TopicContainer = (props: PropTypes) => {
  const { data, location, config } = props
  const { topic, viewer } = data
  const topicPath = topic.breadcrumbs[topic.breadcrumbs.length - 1].path
  if (topic === null) {
    props.staticContext.status = 404
    return null
  }

  return (
    <MainTemplate
      title={topic.pageTitle}
      description={topic.pageDescription}
      image={topic.image ? topic.image : imagePath('www/common/ogimage.png')}
      linkCanonical={`${config.ORIGIN}${location.pathname}`}
      {...props}
    >
      <Breadcrumbs breadcrumbs={topic.breadcrumbs} />
      <TopicPage topic={topic} currentUser={viewer} topicPath={topicPath} />
    </MainTemplate>
  )
}

const topicQuery = gql`
query Topic (
  $uid: String!,
) {
  ${searchMasterFragment}
  topic(uid: $uid) {
    uid
    title
    pageTitle
    leadStatement
    pageDescription
    image
    subImage
    themeColor
    breadcrumbs {
      title
      path
    }
    topicContents {
      results {
        id
        contentType
        title
        titleDecoration
        leadStatement
        leadStatement2
        leadStatement3
        buttonTitle
        linkUrl
        sortOrder
        topicContentItems {
          results {
            id
            title
            content
            image
            buttonTitle
            linkUrl
            priceText
            capacity
            area
            sortOrder
          }
        }
      }
    }
  }
  viewer {
    ${viewerFragment}
  }
}`

const withData = graphql(topicQuery, {
  options: (props: PropTypes) => ({
    variables: {
      uid: props.match.params.topicUid || '',
    },
  }),
})(TopicContainer)

function mapStateToProps(state: Object) {
  return state
}

export default withRouter(connect(mapStateToProps)(withData))



// WEBPACK FOOTER //
// ./src/containers/pages/TopicPage.jsx